import { AccountTypeID } from "../../config/Constants"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { OrderResultsGridRequest } from "./OrderResultModel/OrderResultGridRequest"
import { OrderResultGridResponse } from "./OrderResultModel/OrderResultGridResponse"

function columnFilters(options: OrderResultsGridRequest) {
    const filters = options.filters || []
    return {
        AuthorizationID: filters.find(filter => filter.column === "AuthorizationID")?.values || [],
        Clinic: filters.find(filter => filter.column === "Clinic")?.values || [],
        Company: filters.find(filter => filter.column === "Company")?.values || [],
        EventDate: filters.find(filter => filter.column === "EventDate")?.values || [],
        CollectionTime: filters.find(filter => filter.column === "CollectionTime")?.values || [],
        IDNumber: filters.find(filter => filter.column === "IDNumber")?.values || [],
        LabAccountNumber: filters.find(filter => filter.column === "LabAccountNumber")?.values || [],
        Location: filters.find(filter => filter.column === "Location")?.values || [],
        Name: filters.find(filter => filter.column === "Name")?.values || [],
        OrderDate: filters.find(filter => filter.column === "OrderDate")?.values || [],
        OrderedBy: filters.find(filter => filter.column === "OrderedBy")?.values || [],
        OrderUpdatedAt: filters.find(filter => filter.column === "OrderUpdatedAt")?.values || [],
        OrderUpdatedBy: filters.find(filter => filter.column === "OrderUpdatedBy")?.values || [],
        RAImageID: filters.find(filter => filter.column === "RAImageID")?.values || [],
        Reason: filters.find(filter => filter.column === "Reason")?.values || [],
        Region: filters.find(filter => filter.column === "Region")?.values || [],
        Regulated: filters.find(filter => filter.column === "Regulated")?.values || [],
        ReportDate: filters.find(filter => filter.column === "ReportDate")?.values || [],
        Result: filters.find(filter => filter.column === "Result")?.values || [],
        SampleID: filters.find(filter => filter.column === "SampleID")?.values || [],
        Service: filters.find(filter => filter.column === "Service")?.values || [],
        MarketPlaceOrderNum: filters.find(filter => filter.column === "MarketPlaceOrderNum")?.values || [],
        CreateOrderCompanyName: filters.find(filter => filter.column === "CreateOrderCompanyName")?.values || [],
    }
}

function gridParams(options: OrderResultsGridRequest, accountTypeID: number): string {
    return JSON.stringify({
        AccountTypeID: accountTypeID,
        ColumnFilters: columnFilters(options),
        DateFrom: "1/01/0001 00:00:00",
        DateTo: "1/01/0001 00:00:00",
        ExportDateFrom: options.exportDateFrom,
        ExportDateTo: options.exportDateTo,
        Exact: false,
        Filters: {
            Company: [],
            DateRange: "",
            DateType: "",
            EndDate: "",
            Location: [],
            Reason: [],
            Region: [],
            Regulated: "Regulated & Non-Regulated",
            Service: [],
            StartDate: "",
            Status: "In Process"
        },
        InProcessStatus: true,
        IsMarketPlace: true,
        IsReviewed: options.complete,
        IncludeArchived: options.includeArchived,
        Mask: options.text || "",
        PageNumber: options.pageNumber,
        PageSize: options.pageSize || 20,
        Pending: true,
        SearchBy: options.field || "AllIDs",
        SortGrid: { SortColumn: options.sort?.column || "", SortOrder: options.sort?.order.toUpperCase() === "DESC" ? "DSC" : options.sort?.order.toUpperCase() },
        Type: "All"
    })
}

function printParams(options: OrderResultsGridRequest, accountTypeID: number) {
    const request = JSON.stringify({
        AccountTypeID: accountTypeID,
        ColumnFilters: columnFilters(options),
        Filters: {
            Company: [],
            Location: [],
            Reason: [],
            Region: [],
            Service: [],
            Status: "In Process"
        },
        IsSearch: !!options.text,
        SearchBy: options.field || "AllIDs",
        SearchString: options.text || "",
        TrackPersonID: options.print || []
    })
    return request
}

export const ResultsGridObservable = (params: OrderResultsGridRequest, accountTypeID: number = AccountTypeID) => ObservableFromFetch<OrderResultGridResponse>("WorkforceTrack/GetColumnTrackingGrid", gridParams(params, accountTypeID))
export const OrderResultsExportCsv = (params: OrderResultsGridRequest, accountTypeID: number = AccountTypeID) => ObservableFromFetch<string>("WorkforceTrack/ExportTrackRecord", gridParams(params, accountTypeID))
export const OrderResultsPrint = (params: OrderResultsGridRequest, accountTypeID: number = AccountTypeID) => ObservableFromFetch<string>("WorkforceTrack/PrintTrackRecord", printParams(params, accountTypeID))
